import React, { memo, useState, useEffect } from "react";
import { RequestBookingService } from "../../services/RequestBookingService";
import { getCarModelByName } from "../../services/carModelService";
import { Booking, Payment } from '../../models/booking'
import { CarModel } from '../../models/CarModel'
import { paymentStatusColor } from "../components/common/bookingUtils"

interface EstimatedFareReadOnlyProps {
  booking: Booking;
}

const EstimatedFareReadOnly: React.FC<EstimatedFareReadOnlyProps> = ({ booking }) => {
  const [selectedCarModel, setSelectedCarModel] = useState<CarModel | null>()


  useEffect(() => {
    const fetchCarModel = async () => {
      const selectedModel = await getCarModelByName(booking.selectedCarModel)
      setSelectedCarModel(selectedModel)
    };

    fetchCarModel();
  }, [booking]);

  return (
    <div className="card w-100 mb-3 shadow-sm">
      <div className="card-body">
        <div className="row mb-2">
          <div className="col-6 text-start">
            <strong>Total Distance</strong>
          </div>
          <div className="col-6 text-end">
            <strong>
              {booking ? (booking.returnRide ? booking.payment?.extraKms + 150 * 2 : booking.payment?.extraKms + 150) : 0} Km
          </strong>
          </div>
        </div>

        <div className="row mb-1">
          <div className="col-8 text-start">Base Fare ({booking?.returnRide ? 300 : 150} km)</div>
          <div className="col-4 text-end">₹{booking?.payment?.baseFare}</div>
        </div>

        <div className="row mb-1">
          <div className="col-7 text-start">Extra Km ({booking?.payment?.extraKms})</div>
          <div className="col-5 text-end">₹{booking?.payment?.extraKmCharges}</div>
        </div>

        <div className="row mb-1">
          <div className="col-6 text-start">GST (5%)</div>
          <div className="col-6 text-end">₹{booking?.payment?.gstFare}</div>
        </div>

        <div className="row mb-1">
          <div className="col-7 text-start">Toll </div>
          <div className="col-5 text-end">₹{booking?.payment?.toll}</div>
        </div>

        <div className="row mb-1">
          <div className="col-6 text-start">Parking</div>
          <div className="col-6 text-end">₹{booking?.payment?.parking}</div>
        </div>

        <div className="row mb-1">
          <div className="col-7 text-start  fw-bold">{`Discount${booking.couponCode !== "NA" ? ` (${booking.couponCode})` : ''}`}</div>
          <div className="col-5 text-end  fw-bold">₹{booking?.payment?.discount}</div>
        </div>

        <div className="col-12">
          <hr className="my-1" />
        </div>

        <div className="row mt-2">
          <div className="col-6 text-start fw-bold" style={{ color: paymentStatusColor(booking) }} >Total Fare</div>
          <div className="col-6 text-end  fw-bold" style={{ color: paymentStatusColor(booking) }}  >₹{(booking?.payment?.totalFare)}</div>
        </div>
      </div>
    </div>

  );
};

export default memo(EstimatedFareReadOnly);
